import { useState } from 'preact/hooks';
import type { Currency, GeographyRollup } from '../../shared/types';
import { Donut, type DonutSlice } from './Donut';

const REGION_COLORS = [
  'var(--region-1)', 'var(--region-2)', 'var(--region-3)',
  'var(--region-4)', 'var(--region-5)', 'var(--region-6)',
  'var(--region-7)', 'var(--region-8)', 'var(--region-9)',
  'var(--region-10)',
];

function isGlobal(region: string): boolean {
  return region === 'Global' || region === 'global';
}

export function GeographyDonut({
  rollup,
  ccy,
}: {
  rollup: GeographyRollup[];
  ccy: Currency;
}) {
  const [includeGlobal, setIncludeGlobal] = useState(false);
  const filtered = includeGlobal ? rollup : rollup.filter((r) => !isGlobal(r.region));
  const slices: DonutSlice[] = filtered.map((r, i) => ({
    id: r.region,
    label: r.region,
    value: ccy === 'USD' ? r.value_usd : r.value_eur,
    color: REGION_COLORS[i % REGION_COLORS.length]!,
  }));
  const hasGlobal = rollup.some((r) => isGlobal(r.region));
  return (
    <>
      <div class="panel-title-row">
        <h3 class="panel-title panel-title--flush">Geography</h3>
        {hasGlobal && (
          <div class="seg" role="tablist" aria-label="Geography filter">
            <button
              type="button"
              class={`seg-btn ${!includeGlobal ? 'is-active' : ''}`}
              onClick={() => setIncludeGlobal(false)}
              aria-pressed={!includeGlobal}
            >
              Regional
            </button>
            <button
              type="button"
              class={`seg-btn ${includeGlobal ? 'is-active' : ''}`}
              onClick={() => setIncludeGlobal(true)}
              aria-pressed={includeGlobal}
            >
              All
            </button>
          </div>
        )}
      </div>
      <Donut data={slices} ccy={ccy} ariaLabel="Geographic allocation" />
    </>
  );
}
